import { Link } from 'react-router-dom';
import { articles } from '../../../mocks/articles';

export default function HotNews() {
  const hotSlugs = [
    'X88-leading-brand-football-betting-vietnam.html',
    'year-end-promotion-10-free-vr-lottery-tickets-89bet.html',
    'play-tp-lottery-at-n88.html',
    'sunwin-cong-giai-tri-truc-tuyen-chat-luong-va-tan-tam-nhat.html',
    'iwin-giai-tri-moi-luc-moi-noi-cung-kho-game-sieu-da-dang.html',
    'max88-the-gioi-giai-tri-truc-tuyen-dang-lam-mua-lam-gio.html',
    'b52club-tan-huong-khong-gian-game-hien-dai.html',
    '23win-san-choi-doi-thuong-dinh-cao.html',
    'debet-huong-dan-truy-cap-chinh-chu-moi-nhat-2025.html',
    'a-complete-guide-to-veewin-card-games-online-insights.html',
    'premier-league-fixtures-2025.html',
  ];

  const hotArticles = hotSlugs
    .map(slug => articles.find(a => a.slug === slug))
    .filter((a): a is NonNullable<typeof a> => Boolean(a))
    .slice(0, 10);

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h3 className="text-lg font-bold mb-4 pb-2 border-b-2 border-blue-600">
        HOT NEWS
      </h3>
      <div className="space-y-3">
        {hotArticles.map((article) => (
          <Link
            key={article.id}
            to={`/libraries/pgss/${article.slug}`}
            className="flex gap-3 hover:bg-gray-50 p-2 rounded transition-colors group"
          >
            <img
              src={article.image}
              alt={article.title}
              className="w-20 h-20 object-cover rounded flex-shrink-0"
              loading="lazy"
            />
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold line-clamp-2 group-hover:text-blue-600 transition-colors mb-1">
                {article.title}
              </h4>
              <p className="text-xs text-gray-500">{article.date}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}